import { DatePicker, Descriptions, Select } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createRegularOcean, updateRegularOcean } from "../../../api/oceanManagement.api";
import useAuth from "../../../hooks/useAuth";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";
import { IRegularOcean } from "../../../models/oceanManagement.model";
import { RootState } from "../../../store/rootReducer";
import Button from "../../Button";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";

interface IProps {
  scheduleCode?: number;
  data?: IRegularOcean;
}

const RegularEditor: FC<IProps> = ({
  scheduleCode,
  data,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { writeAuthYn } = useAuth();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { infoNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [isCreate, setIsCreate] = useState(true);
  const [eduStepCode, setEduStepCode] = useState<string>();
  const [name, setName] = useState('');
  const [srtDate, setSrtDate] = useState('');
  const [endDate, setEndDate] = useState('');

  useEffect(() => {
    if (data) {
      setIsCreate(false);
      setEduStepCode(data.eduStepCode);
      setName(data.name);
      setSrtDate(data.srtDate);
      setEndDate(data.endDate);
    }
  }, [data]);

  useEffect(() => {
    if (submitRes && submitIsLoading) {
      infoNotification(t('common.message.save1'));
      history.push('/class/ocean');
    }
  }, [submitRes, submitIsLoading]);

  const onSubmit = () => {
    if (!currentCampus) return;

    if (!eduStepCode) {
      return infoNotification(t('class.class.26'));
    }
    if (!name) {
      return infoNotification(t('class.ocean.message1'));
    }
    if (!srtDate) {
      return infoNotification(t('class.ocean.message2'));
    }
    if (!endDate) {
      return infoNotification(t('class.ocean.message3'));
    }
    if (moment(srtDate).isAfter(endDate)) {
      return infoNotification(t('class.ocean.message4'));
    }
    if (moment(endDate).diff(moment(srtDate), 'days') < 7 || moment(endDate).diff(moment(srtDate), 'days') > 30) {
      return infoNotification(t('class.ocean.message5'));
    }

    const req: any = {
      campusCode: isCreate ? currentCampus : data!.campusCode,
      eduStepCode,
      name,
      srtDate,
      endDate,
    };

    isCreate
      ? submitExecute(createRegularOcean(req))
      : submitExecute(updateRegularOcean(scheduleCode!, req))
  }  
  return (
    <>
      {submitIsLoading && <Loader />}
      <ErrorResponse error={submitError} />

      <div className='comm-table__area rowType'>
        <Descriptions
          bordered
          column={2}
          size="small"
          labelStyle={{ width: '15%' }}
          contentStyle={{ width: '35%' }}
        >
          <Descriptions.Item label={t('class.class.9')} span={2}>
            <Select
              className="w-150p"
              placeholder={t('student.student.placeholder6')}
              value={eduStepCode} 
              onChange={value => setEduStepCode(value)}
              disabled={!!data}
            >
              <Select.Option value="EM">OCEAN</Select.Option>
              <Select.Option value="MD">Prediger</Select.Option>
            </Select>
          </Descriptions.Item>
          <Descriptions.Item label={t('class.ocean.column1')} span={2}>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('class.ocean.column2')}>
            <div className="date-picker__area">
              <DatePicker
                value={srtDate ? moment(srtDate) : undefined}
                onChange={e => {
                  if (e === null) setSrtDate('');
                  else setSrtDate(moment(e).format('YYYYMMDD'))
                }}
              />
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t('class.ocean.column3')}>
            <div className="date-picker__area">
              <DatePicker
                value={endDate ? moment(endDate) : undefined}
                onChange={e => {
                  if (e === null) setEndDate('');
                  else setEndDate(moment(e).format('YYYYMMDD'))
                }}
              />
            </div>
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            onClick={() => history.push('/class/ocean')}
            className="btn-basic gray-line"
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area">
          <Button
            onClick={onSubmit}
            className="btn-basic pink"
            text={isCreate ? t('common.button.save') : t('common.button.edit')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
    </>
  );
}

export default RegularEditor;
